import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  withRouter
} from "react-router-dom";
import { history } from '../helper/history';
import localdata from '../helper/localdata';
import swal from 'sweetalert';
import { NavLink } from 'react-router-dom';
import Login from '../component/login'
import ForgotPassword from '../component/forgot_password'
import config from '../helper/config'

const routes = [
  {
    path: "/login",
    component: Login
  },
  {
    path: "/forgot-password",
    component: ForgotPassword
  }
];

const RouteWithSubRoutes = route => (
  <Route
    path={route.path}
    render={props => (
      <route.component {...props} routes={route.routes} />
    )}
  />
);

class LoginRegister extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    render() {
        let body_contact_admin = '%0A%0A%0Aug: ' + navigator.userAgent
        return (
            <Router>
                <div className="m-grid m-grid--hor m-grid--root m-page">
                    {routes.map((route, i) => <RouteWithSubRoutes key={i} {...route} />)}
                      <footer className="m-grid__item m-footer" style={{boxShadow:'none',background:'none',position:'fixed',bottom: 0,right: 0,padding:'7px 10px'}}>
                      <div className="m-container m-container--fluid m-page__container" style={{width:'300px',position:'fixed',right: 0}}>
                          <div className="m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop">
                              <div className="m-stack__item m-stack__item--right m-stack__item--middle m-stack__item--first">
                                  <ul className="m-footer__nav m-nav m-nav--inline m--pull-right">
                                      <li className="m-nav__item m-nav__item">
                                          <a className="m-nav__link">
                                              <span className="m-footer__copyright" style={{verticalAlign: 'middle',display: 'table-cell'}}>
                                                  2018 &copy; PT POS INDONESIA
                                              </span>
                                          </a>
                                      </li>
                                      <li className="m-nav__item m-nav__item">
                                          <a href={'mailto:' + config.helpdesk_email + '?body=' + body_contact_admin} target="_top" data-container="body" className="m-nav__link" title="Customer Service" data-placement="login" style={{cursor:'pointer'}}>
                                              <i className="m-nav__link-icon flaticon-info" style={{fontSize: '25px'}}></i>
                                          </a>
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </footer>
                </div>
            </Router>
        )
    }
}

export default LoginRegister


// WEBPACK FOOTER //
// ./src/page/login_register.js